import React, { useMemo } from 'react'
import { SiteSlidebarRightSecond } from '../../General/SiteSlidebars'
import { trackMoviePerformanceClose, trackMoviePerformanceOpen } from '../../tracking'
import getBackgroundsUrlsObj from '../../functions/getBackgroundsUrlsObj'
import PerformanceSectionContainer from '../../PerformancePage/PerformanceSectionContainer'

const FilterMovieInformation = ({
    activeItem, 
    additionalScrollName,
    itemsData,
    displaySidebarRightSecond,
    toggleMovieDatesOnMobileView,
    currentDateActive,
    activePerformance,
    performancePageOpen,
    onOpenPerformancePage,
    onClosePerformancePage,
    isMobile,
    eventOrigins,
    hideCinemaSelector,
    queryStringValues,
    filterType,
    filterValue,
    activeCinema
}) => {
    if (!itemsData) {
        return ''
    }
    const movieData = itemsData[activeItem]

    if (!movieData || !activeItem) {
        return ''
    }

    const images = movieData.images

    const backgroundsObj = useMemo(
        () => getBackgroundsUrlsObj(images), 
        [images]
    )
    
    const backgroundImage = backgroundsObj.performance

    return (
        <div className={"order-wrapper movie-information-is-open"}>
            {!displaySidebarRightSecond && performancePageOpen && <PerformanceSectionContainer
                activeItem={activeItem}
                hideCinemaSelector={hideCinemaSelector}
                filterValue={filterValue}
                filterType={filterType}
                queryStringValues={queryStringValues}
                isMobile={isMobile}
                activePerformance={activePerformance}
                activeCinema={activeCinema}
                moviesData={itemsData}
                scrollToPosition={activeItem + '-' + activePerformance.timeUtc + additionalScrollName}
                currentDateActive={currentDateActive}
                backgroundImage={backgroundImage}
                toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView}
                onOpenPerformancePage={trackMoviePerformanceOpen(onOpenPerformancePage, eventOrigins.performance)}
                onClosePerformancePage={trackMoviePerformanceClose(onClosePerformancePage, eventOrigins.performance)}
                />}

            {displaySidebarRightSecond && performancePageOpen && <SiteSlidebarRightSecond>
                <PerformanceSectionContainer
                    filterValue={filterValue}
                    isMobile={isMobile}
                    filterType={filterType}
                    queryStringValues={queryStringValues}
                    activeItem={activeItem}
                    activePerformance={activePerformance}
                    moviesData={itemsData}
                    scrollToPosition={activeItem + '-' + activePerformance.timeUtc + additionalScrollName}
                    currentDateActive={currentDateActive}
                    backgroundImage={backgroundImage}
                    performancePageMovieTimes={true}
                    toggleMovieDatesOnMobileView={toggleMovieDatesOnMobileView}
                    onOpenPerformancePage={trackMoviePerformanceOpen(onOpenPerformancePage, eventOrigins.performance)}
                    onClosePerformancePage={trackMoviePerformanceClose(onClosePerformancePage, eventOrigins.performance)}
                />
            </SiteSlidebarRightSecond>}
        </div>
    )
}


export default FilterMovieInformation